module.exports = new __parcel__URL__("hud-button-hover.82c28e77.wav").toString();